// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2QRH6","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3mz8a"};